export type InputSize = "small" | "regular" | "big" | "biggest";
export type InputMode = "outlined" | "flat";
